var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNuwayLogoHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 680.89 180",
    role: "img",
    "aria-label": "NUWAY",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NUWAY") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(86.2 90)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#30251F",
    strokeWidth: 18,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    id: "n",
    d: "M-40.2 73.72C-58.2 60.72 -68.2 46.72 -68.2 19.72L-68.2 -23.28A46.5 46.5 0 0 1 24.8 -23.28L24.8 19.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u",
    d: "M-21.2 -22.28L-21.2 23.49A43.73 43.73 0 0 0 66.25 23.49L66.25 -23.28C66.25 -29.28 65.75 -33.28 64.25 -39.28"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "dot",
    cx: 63.75,
    cy: -63.28,
    r: 14.5,
    fill: "#F5C400"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(214.48 126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "wordmark",
    fill: "#30251F",
    d: "M59.65714285714286 -72.0V-25.919999999999998L7.817142857142857 -75.6V0.0H21.18857142857143V-46.08L72.92571428571428 3.6V-72.0Z M104.60571428571427 -72.0V-23.65714285714286Q104.60571428571427 -17.485714285714284 106.61142857142856 -12.651428571428571Q108.61714285714285 -7.817142857142857 112.26857142857142 -4.5771428571428565Q115.91999999999999 -1.3371428571428572 120.90857142857142 0.4114285714285715Q125.89714285714285 2.16 131.65714285714284 2.16Q137.51999999999998 2.16 142.45714285714286 0.4114285714285715Q147.3942857142857 -1.3371428571428572 151.09714285714284 -4.5771428571428565Q154.79999999999998 -7.817142857142857 156.7542857142857 -12.651428571428571Q158.70857142857142 -17.485714285714284 158.70857142857142 -23.65714285714286V-72.0H145.0285714285714V-24.377142857142857Q145.0285714285714 -18.102857142857143 141.68571428571425 -14.194285714285714Q138.34285714285713 -10.285714285714285 131.65714285714284 -10.285714285714285Q125.07428571428571 -10.285714285714285 121.73142857142857 -14.194285714285714Q118.38857142857142 -18.102857142857143 118.38857142857142 -24.377142857142857V-72.0Z M256.1142857142857 -25.817142857142855 235.64571428571426 -75.6 215.48571428571427 -25.817142857142855 199.2342857142857 -72.0H183.1885714285714L213.11999999999998 4.011428571428572L235.64571428571426 -44.74285714285714L258.1714285714286 4.011428571428572L288.10285714285715 -72.0H272.15999999999997Z M322.55999999999995 -17.177142857142858H360.6171428571428L358.6628571428571 -28.285714285714285H324.6171428571428ZM341.3828571428571 -49.885714285714286 352.4914285714285 -24.17142857142857V-20.674285714285713L361.9542857142857 0.0H377.3828571428571L341.3828571428571 -76.11428571428571L305.3828571428571 0.0H320.9142857142857L330.5828571428571 -21.394285714285715L330.47999999999996 -24.377142857142857Z M441.77142857142854 -72.0 425.8285714285714 -42.27428571428571 409.88571428571424 -72.0H394.1485714285714L418.9371428571428 -29.931428571428572V0.0H432.8228571428571V-30.034285714285712L457.4057142857143 -72.0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuwayLogoHorizontal);
export default __webpack_public_path__ + "static/media/nuway-logo-horizontal.4bf7454b278832f0944cc1c9e21ae86b.svg";
export { ForwardRef as ReactComponent };